import { NAVLINKS, siteSettings } from '@workspace/utils';
import './style.css';
const navClone = [...NAVLINKS]; // or NAVLINKS.slice()

const footerConfig = {
  menus: [
    {
      title: "Admissions Consulting",
      links: navClone.slice(0, 6).map(item => ({
        text: item.title,
        href: item.href,
      }))
    },
    {
      title: "Resources",
      links: [
        // { text: "Content library", href: "/library" },
        { text: "Webinars", href: "/resource/webinars" },
        { text: "Guides", href: "/resource/guides" },
        // { text: "Tools", href: "/resources/tools" },
        // { text: "Podcasts", href: "/resources/podcasts" },
        { text: "Career Studio", href: "/career-studio", },
        { text: "Profile Evaluation", href: "/profile-evaluation" },
        // { text: "Help centre", href: "https://help.us.com/hc/en-us", target: "_blank" },
      ]
    },
    {
      title: "Company",
      links: [
        { text: `About ${siteSettings.siteName}`, href: "/about" },
        { text: "Book an Expert call", href: "/lets-talk" },
        // { text: "Contact", href: "/contact" },
        { text: "Careers", href: "/careers" },
      ]
    },
    {
      title: "Connect",
      links: [
        { text: siteSettings.social.LinkedIn.label, href: siteSettings.social.LinkedIn.url, target: "_blank" },
        // { text: siteSettings.social.instagram.label, href: siteSettings.social.instagram.url, target: "_blank" },
        { text: siteSettings.social.instagram.label, href: siteSettings.social.instagram.url, target: "_blank" },
        { text: "Email support", href: `mailto:${siteSettings.contact.email}` },
        // { text: siteSettings.contact.phone, href: `tel:${siteSettings.contact.phone}` },
        { text: "WhatsApp", href: `${siteSettings.contact.whatsappUrl}`, target: "_blank" },

        // { text: "Sign in", href: "https://app.us.com/login", target: "_blank" },
      ]
    }
  ],
  legal: [
    { label: "Terms and conditions", href: "/legal/terms" },
    { label: "Privacy policy", href: "/legal/privacy-policy" },
    { label: "Refund, Deferral & Payment Terms", href: "/legal/refund-policy" },
    { label: "Disclaimer", href: "/legal/disclaimer" },
    { label: "Copyright Notice", href: "/legal/copyright-notice" },
    { label: "Contact / Impressum", href: "/legal/contact-impressum" },
  ],
  copyright: `@${(new Date()).getFullYear()} ${siteSettings.siteName}. All rights reserved.`
};

export function FooterDetailed({ }: {}) {
  const { menus, legal, copyright } = footerConfig;

  // Function to split menus with more than 3 items into multiple menus
  const processMenus = (menus: typeof footerConfig.menus) => {
    const processedMenus: Array<{ title: string; isSplit?: boolean; links: Array<{ text: string; href: string; target?: string }> }> = [];

    menus.forEach((menu, index) => {
      if (menu.links.length > 3 && index == 0) {
        // Split into chunks of 3
        for (let i = 0; i < menu.links.length; i += 3) {
          const chunk = menu.links.slice(i, i + 3);
          processedMenus.push({
            title: i === 0 ? menu.title : "", // Only show title for first chunk
            isSplit: true,
            links: chunk
          });
        }
      } else {
        processedMenus.push(menu);
      }
    });

    return processedMenus;
  };

  const processedMenus = processMenus(menus);

  return (
    <div className="footer_component">
      <div className="padding-global">
        <div className="container-large">
          {/* <div className="footer_top-wrapper">
            <div className="footer_left-image-wrapper">
              <img src={images.left.src} loading="lazy" alt={images.left.alt} className="footer_left-image" />
            </div>
            <div className="cta_content-wrapper">
              <h2 className="text-color-white">{cta.heading}</h2>
              <div className="margin-top margin-medium">
                <div className="button-row">
                  <a href={cta.button.href} className="button w-button">{cta.button.text}</a>
                </div>
              </div>
            </div>
            <div className="footer_right-image-wrapper hide-tablet">
              <div className="footer_background"></div>
              <img src={images.right.src} loading="lazy" alt={images.right.alt} className="footer_right-image" />
            </div>
          </div> */}
          <div className="footer_center-wrapper">
            <div className="padding-bottom padding-xxlarge">
              <div className="footer_content-wrapper">
                <div className="footer_list-wrapper">
                  {processedMenus.map((menu, i) => (
                    <div className={`footer_menu ${menu.isSplit? 'mt-0' : ''}`} key={`${menu.title}-${i}`}>
                      {menu.title && (
                        <div className="margin-bottom margin-small">
                          <div className="text-color-white h-6">{menu.title}</div>
                        </div>
                      )}
                      <div className={`footer_menu-list ${(menu.isSplit && menu.title === '') ? 'mt-9' : ''}`}>
                        {menu.links.map((link) => (
                          <a
                            key={link.text}
                            href={link.href}
                            className="footer_link"
                            {...(link.target ? { target: link.target } : {})}
                          >
                            {link.text}
                          </a>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="footer_bottom-wrapper">
            <div className="footer_bottom-left">
              <div className="footer_meta-list">
                {legal.map(item => (
                  <a key={item.href} href={item.href} className="text-size-tiny is-copyright-link">
                    {item.label}
                  </a>
                ))}
              </div>
              <div className="text-size-tiny is-copyright-text">{copyright}</div>
            </div>
            <div className="footer_bottom-right"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

